import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import NewAlbumModal from '../modals/NewAlbumModal';
import AlbumList from '../components/AlbumList';
import AlbumListState from '../states/AlbumListState';
import Album from '../models/Album';

const translationPrefix = 'kilowhat-cimaise.forum.album-list.';

export default class AlbumListPage extends Page {
    albumList!: AlbumListState

    oninit(vnode: any) {
        super.oninit(vnode);

        this.albumList = new AlbumListState();
        this.albumList.refresh();
    }

    view() {
        return m('.container', [
            m('h2', app.translator.trans(translationPrefix + 'title')),
            app.forum.cimaiseCanCreateAlbums() ? Button.component({
                className: 'Button Button--primary',
                onclick: () => {
                    app.modal.show(NewAlbumModal, {
                        onsave: (album: Album) => {
                            this.albumList.addAlbum(album);
                        },
                    });
                },
            }, app.translator.trans(translationPrefix + 'new')) : null,
            m(AlbumList, {
                state: this.albumList,
            }),
        ]);
    }
}
